export default class TransactionalEmails implements IDigitalIdentityHubModule {
  public name = "TransactionalEmails";

  public init(): void { /* No functionality */ }

  public ready(): void {
    let email: string;
    // reset password email
    janrain.events.onCaptureEmailSent.addHandler(function(result) {
      email = result.to;
      if (
        janrain.settings.capture.currentScreenName === "forgotPasswordSuccess" ||
        janrain.settings.capture.currentScreenName === "preregCreatePasswordRequestCodeSuccess" ||
        janrain.settings.capture.currentScreenName === "forgotPassword" ||
        janrain.settings.capture.currentScreenName === "resetPasswordRequestCodeSuccess"
      ) {
        void window.fetch(`${window.DigitalIdentityHub.settings.transactionalEmailsEndpoint}/resetPassword`, {
          method: "POST",
          headers: {
            "x-api-key": `${window.DigitalIdentityHub.settings.transactionalEmailsKey}`
          },
          body: JSON.stringify({
            email,
            clientId: janrain.settings.capture.clientId
          })
        });
      }
    });

    // Will send re-verification email when resendVerificationSuccess screen is rendered
    janrain.events.onCaptureScreenShow.addHandler(() => {
      if (janrain.settings.capture.currentScreenName === "resendVerificationSuccess") {
        window.setTimeout(() => {
          void window.fetch(`${window.DigitalIdentityHub.settings.transactionalEmailsEndpoint}/verifyEmail`, {
            method: "POST",
            headers: {
              "x-api-key": `${window.DigitalIdentityHub.settings.transactionalEmailsKey}`
            },
            body: JSON.stringify({
              uuid: JSON.parse(localStorage.janrainCaptureProfileData || "{}").uuid,
              clientId: janrain.settings.capture.clientId,
              email
            })
          });
        }, 0);
      }
    });

    // Sending Transactional Email when profile is updated
    janrain.events.onCaptureProfileSaveSuccess.addHandler(async function(result) {
      if (
        janrain.settings.capture.profileUpdatedEmailConfigured &&
        result.statusMessage === "profileSaved" && (
          result.screen === "editProfile" ||
          result.screen === "changePassword"
        )
      ) {
        const response = await window.fetch(`${window.DigitalIdentityHub.settings.transactionalEmailsEndpoint}/profileUpdated`, {
          method: "POST",
          headers: {
            "x-api-key": `${window.DigitalIdentityHub.settings.transactionalEmailsKey}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ uuid: JSON.parse(localStorage.janrainCaptureProfileData || "{}").uuid })
        });

        const text = await response.text();

        console.log(text);
      }
    });
  }
}
